import React, { FC } from 'react'
import { format } from '@dt/fe-utils'
import './couponItem.scss'
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  coupon: IDiscountItemCoupon | IDiscountCoupon;
}

const CouponDisabledItem: FC<IProps> = ({ coupon }) => {
  return (
    <div
      className='mall-coupon-disable-item-wrapper'
    >
      <div className='coupon-item-top'>
        <div className='coupon-item-l'>
          <h3>
            {coupon.discountType === 'discountFee' || coupon.discountType === 'specialOffer' ? (<span><small>{format.toCurrency()}</small>{format.toPrice(coupon.discountValue, -1, false)}</span>) : format.toDiscount('discountRate', coupon.discountValue)}
          </h3>
          {
            coupon.orderFee ? (
              <h5>{i18n.t('cart.full', { money: format.toPrice(coupon.orderFee, -1, false) })}</h5>
            ) : null
          }
        </div>
        <div className='coupon-item-r'>
          <h5>{coupon.couponName}</h5>
          <h6>
            {
              coupon.isForever ? i18n.t('cart.permanent') : format.toMonthDateYear(coupon.startTime) + ' - ' + format.toMonthDateYear(coupon.endTime)
            }
          </h6>
          <h6>
            {
              coupon.isAllTime ? i18n.t('cart.allday') : i18n.t('cart.not_allday')
            }
          </h6>
        </div>
      </div>
      {
        !!coupon.reason && (
          <div className='coupon-item-bottom'>
            {coupon.reason}
          </div>
        )
      }
    </div>
  )
}
export default CouponDisabledItem
